// extracted by mini-css-extract-plugin
export var feeditem = "FeedItem-module--feeditem--e6f7w";
export var feeditem_title = "FeedItem-module--feeditem_title--3gkF3";
export var feeditem_title_link = "FeedItem-module--feeditem_title_link--5fV67";
export var feeditem_description = "FeedItem-module--feeditem_description--GoMGr";
export var feeditem_meta_time = "FeedItem-module--feeditem_meta_time--VU8vl";
export var feeditem_meta_divider = "FeedItem-module--feeditem_meta_divider--cl6xo";
export var feeditem_meta_category_link = "FeedItem-module--feeditem_meta_category_link--1-bJC";
export var feeditem_readmore = "FeedItem-module--feeditem_readmore--2vuB-";